<template>
    <div class="text-center lh80 itistar-dividing">
        <p class="fs18 c-g-d route-link-title">
            <slot></slot>
        </p>
    </div>
</template>

<script>
export default {
    name: "IristarDividing"
};
</script>

<style lang="less">
.route-link-title a {
    color: #333;
    text-decoration: none;
}
</style>